import { NavLink } from 'react-router-dom';
import CoTaskrLogo from '@/components/auth/CoTaskrLogo';
import TenantLogoImage, { resolveTenantLogoSrc } from '@/components/common/TenantLogoImage';
import { getHomeRouteForRole } from '@/utils/homeRoute';
import { getProductEntryRoute } from '@/utils/productAccess';
import { UserRole, type UserRole as UserRoleType } from '@/types';

type SidebarBrandMarkProps = {
  logoUrl?: string | null;
  orgName?: string;
  userRole?: UserRoleType;
  isCollapsed: boolean;
};

export default function SidebarBrandMark({
  logoUrl,
  orgName,
  userRole,
  isCollapsed,
}: SidebarBrandMarkProps) {
  const title = orgName || 'CoTaskr';
  const hasLogo = !!resolveTenantLogoSrc(logoUrl);
  const homeTo =
    userRole === UserRole.SUPER_ADMIN
      ? getHomeRouteForRole(userRole)
      : getProductEntryRoute('pm', userRole);
  const showFullCoTaskr = !isCollapsed && !hasLogo;

  return (
    <NavLink
      to={homeTo}
      className={`flex min-w-0 items-center hover:opacity-90 transition-opacity ${
        isCollapsed ? 'flex-1 justify-center' : 'h-full flex-1 px-3'
      }`}
      title={title}
    >
      {hasLogo ? (
        <TenantLogoImage
          src={logoUrl}
          alt={`${orgName ?? 'Organization'} logo`}
          className={
            isCollapsed
              ? 'max-h-8 max-w-8 w-auto object-contain'
              : 'max-h-9 w-auto max-w-[calc(100%-0.5rem)] object-contain object-left'
          }
          fallback={
            <CoTaskrLogo size="sidebar" theme="brand" animated={false} iconOnly={!showFullCoTaskr} />
          }
        />
      ) : (
        <CoTaskrLogo
          size="sidebar"
          theme="brand"
          animated={false}
          iconOnly={!showFullCoTaskr}
        />
      )}
    </NavLink>
  );
}
